import axios from 'axios';

export const CmsApi = axios.create({
    baseURL: `${process.env.REACT_APP_CMS_API}`
})